import PropTypes from 'prop-types';
import { ReactComponent as LockIcon } from 'assets/icons/checkout/lock.svg';
import { ReactComponent as CreditCardIcon } from 'assets/icons/checkout/credit-card.svg';
import { ReactComponent as ShieldIcon } from 'assets/icons/checkout/shield.svg';

const ICONS = {
  lock: LockIcon,
  card: CreditCardIcon,
  shield: ShieldIcon,
};

const MethodDetails = ({ rows, className = '' }) => (
  <ul className={`m-0 list-none space-y-4 rounded-xl bg-white p-4 shadow-card ${className}`}>
    {rows.map(({ icon, title, text }) => {
      const Icon = ICONS[icon];
      return (
        <li key={icon} className='flex items-start gap-3'>
          <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-surface-cream-mid text-primary-700'>
            <Icon aria-hidden='true' className='h-5 w-5' />
          </span>
          <div className='min-w-0'>
            <p className='m-0 text-sm font-semibold text-neutral-900'>{title}</p>
            <p className='m-0 mt-0.5 text-[13px] leading-snug text-neutral-500'>{text}</p>
          </div>
        </li>
      );
    })}
  </ul>
);

MethodDetails.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.oneOf(Object.keys(ICONS)).isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })).isRequired,
  className: PropTypes.string,
};

export default MethodDetails;
